import * as gfunctions from '../../../js/generalFunctions';

CCL.facetCard = {
  autoload: [
    ['filtering', $('.c-category-facets').length > 0],
    // ['rating', $('.facets-rating').length > 0],
    ['onFilterApplyBtn', $('.btn.btn-blue.btn-full').length > 0],
    ['onFilterCancelBtn', $('.btn.btn-blue-link.btn-full').length > 0],
    ['clickFacetHeader', $('.facet-header').length > 0]
  ],

  finalQuery: '',
  firsttime: true,

  collapsing() {
    const cardDoms = document.getElementsByClassName('c-facet-card');
    for (let p = 1; p <= cardDoms.length; p++) {
      // Execute a function when the user releases a key on the keyboard
      document.getElementById('c-facet-card_'.concat(p)).addEventListener('keyup', (event) => {
        // Cancel the default action, if needed
        event.preventDefault();
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
          if (event.path[1].className.indexOf('custom-checkbox') === -1) {
            // Trigger the button element with a click
            document.getElementById('c-facet-card-header_'.concat(p)).click();
          } else {
            event.path[0].checked = !event.path[0].checked;
            if ($.query.get('sort')) {
              $.query.REMOVE('sort');
            }
            if ($.query.get('page')) {
              $.query.REMOVE('page');
            }
            document.location.search = $.query.set('q', $(event.target).data('query'));
          }
        }
      });
    }
  },

  clickFacetHeader() {
    $('.facet-header').on('click keypress', (element) => {
      if (element.type === 'click' || element.keyCode === 13) {
        setTimeout(() => {
          $(element).css('background-color', 'white');
        }, 300);
      }
    });
  },

  filtering() {
    $('.facet-query').change((event) => {
      if ($.query.get('sort')) {
        $.query.REMOVE('sort');
      }
      if ($.query.get('page')) {
        $.query.REMOVE('page');
      }
      if (gfunctions.detectmob()) {
        if (this.finalQuery) {
          if (event.target.checked) {
            let getCurrentQuery = '';
            getCurrentQuery = $(event.target).data('query');
            this.finalQuery = getCurrentQuery.replace(':recommended', this.finalQuery);
          } else {
            let getCurrQuery = '';
            getCurrQuery = $(event.target).data('query');
            const queryText = getCurrQuery.replace(':recommended', '').trim();
            if (this.finalQuery.includes(queryText)) {
              this.finalQuery = this.finalQuery.split(queryText).join(''); // remove filter query if checkox un checked
            }
          }
        } else {
          this.finalQuery = $(event.target).data('query');
        }
        console.log(this.finalQuery);
      } else {
        document.location.search = $.query.set('q', $(event.target).data('query'));
      }
    });

    $('body').on('click keypress', '.view-more-destination', (e) => {
      console.log('view-more-destination');
      if (!$(e.currentTarget).hasClass('expanded')) {
        $(e.currentTarget).attr('aria-expanded', true);
        $(e.currentTarget).addClass('expanded');
        $(e.currentTarget).prev().addClass('expanded-section');
        $(e.currentTarget).attr('aria-label', `View Less ${e.currentTarget.dataset.type} destinations`);
        $(e.currentTarget.parentElement).find('.custom-checkbox').each((index, element) => {
          if (index + 1 > 10) {
            $(element).fadeIn('fast');
            $(element).removeAttr('tabindex');
            $(element).removeAttr('aria-hidden');
            $(element).find('input').removeAttr('tabindex');
            $(element).find('label').removeAttr('aria-hidden');
          }
        });
        $(e.currentTarget).html('View Less');
      } else {
        $(e.currentTarget).attr('aria-expanded', false);
        $(e.currentTarget).removeClass('expanded');
        $(e.currentTarget).prev().removeClass('expanded-section');
        $(e.currentTarget).attr('aria-label', `View More ${e.currentTarget.dataset.type} destinations`);
        this.firsttime = true;

        $(e.currentTarget.parentElement).find('.custom-checkbox').each((index, element) => {
          if (index + 1 > 10) {
            $(element).fadeOut('fast');
            $(element).attr('tabindex', '-1');
            $(element).attr('aria-hidden', 'true');
            $(element).find('input').attr('tabindex', '-1');
            $(element).find('label').attr('aria-hidden', 'true');
          }
        });
        $(e.currentTarget).html('View More');
      }

      $(e.currentTarget).addClass('ada-element-focus');
      setTimeout(() => {
        $(() => {
          $(e.currentTarget).focus();
        });
      }, 100);
    });

    $('body').on('keydown', '.view-more-destination', (e) => {
      if ($(e.currentTarget).hasClass('expanded') && this.firsttime === true) {
        e.preventDefault();
        if (Number(e.which) === 9) {
          $(e.currentTarget).parents('.facet-collapse-section').find('.facet-checkbox-div:nth-child(11) input').focus();
          this.firsttime = false;
        }
      }
    });
    $('body').on('click', '.expand-facet-section', (e) => {
      const parentSection = $(e.currentTarget.parentElement).prev();
      if (!$(e.currentTarget).hasClass('expanded')) {
        $(e.currentTarget).addClass('expanded');
        $(e.currentTarget).prev().addClass('expanded-section');
        $(e.currentTarget).html('View Less');
        $(e.currentTarget).attr('aria-label', `View Less ${e.currentTarget.dataset.type} expanded link`);
        $(e.currentTarget.parentElement.parentElement).find('.custom-checkbox').each((index, element) => {
          if (index + 1 > 20) {
            $(element).fadeIn('slow');
            $(element).removeAttr('tabindex');
            $(element).removeAttr('aria-hidden');
            $(element).find('input').removeAttr('tabindex');
            $(element).find('label').removeAttr('aria-hidden');
          }
        });
        $('html, body').animate({
          scrollTop: parentSection.offset().top + (parentSection[0].clientHeight - 100)
        }, 200);
      } else {
        $(e.currentTarget).removeClass('expanded');
        $(e.currentTarget).prev().removeClass('expanded-section');
        $(e.currentTarget).html('View More');
        $(e.currentTarget).attr('aria-label', `View More ${e.currentTarget.dataset.type} collapsed link`);
        $(e.currentTarget.parentElement.parentElement).find('.custom-checkbox').each((index, element) => {
          if (index + 1 > 20) {
            $(element).fadeOut('slow');
            $(element).attr('tabindex', '-1');
            $(element).attr('aria-hidden', 'true');
            $(element).find('input').attr('tabindex', '-1');
            $(element).find('label').attr('aria-hidden', 'true');
          }
        });
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: parentSection.offset().top + (parentSection[0].clientHeight - 100)
          }, 200);
        }, 800);
      }

      $(e.currentTarget).addClass('ada-element-focus');
      setTimeout(() => {
        $(() => {
          $(e.currentTarget).focus();
        });
      }, 100);
    });
  },

  onFilterApplyBtn() {
    $('.filter-btn-wrap .btn.btn-blue.btn-full').click((event) => {
      $('.c-category-facets').hide();
    });
  },

  onFilterCancelBtn() {
    $('.filter-btn-wrap .btn.btn-blue-link.btn-full').click((event) => {
      $('.c-category-facets').hide();
      $('.filter-btn').attr('aria-label', 'Filter button that contain options to see is collapsed');
      $('body').find('.filter-btn').focus();
    });
  },

  rating() {
    const self = this;
    let SelectedRating = sessionStorage.getItem('SelectedRating');
    if (!SelectedRating) {
      SelectedRating = 0;
    }
    const ratingText = SelectedRating < 5 ? `${SelectedRating} AND UP` : SelectedRating;
    $('.review').find('.review-text').text(ratingText);
    // sessionStorage.removeItem('SelectedRating');
    $('.facets-rating').starRating({
      starSize: 23,
      disableAfterRate: false,
      initialRating: SelectedRating,
      callback(currentRating, $el) {
        // make a server call here
      },
      onHover(currentIndex, currentRating, $el) {
        const text = currentIndex < 5 ? `${currentIndex} AND UP` : currentIndex;
        $($el).parents('.review').find('.review-text').text(text);
      },
      onLeave(currentIndex, currentRating, $el) {
        const text = currentRating < 5 ? `${currentRating} AND UP` : currentRating;
        $($el).parents('.review').find('.review-text').text(text);
      },
      onClick(currentRating, $el) {
        if ($.query.get('sort')) {
          $.query.REMOVE('sort');
        }
        if ($.query.get('page')) {
          $.query.REMOVE('page');
        }
        let rating = currentRating.toString();
        rating = rating.includes('.') ? rating.replace('.', '') : rating;
        sessionStorage.setItem('SelectedRating', rating);
        // for mobile
        if (gfunctions.detectmob()) {
          if (self.finalQuery) {
            let getCurrentQuery = '';
            getCurrentQuery = $($el).data(`rating${rating}`);
            const curQueryText = getCurrentQuery.replace(':recommended', '').trim();
            if (!self.finalQuery.includes(curQueryText)) {
              self.finalQuery = getCurrentQuery.replace(':recommended', self.finalQuery);
            } else {
              self.finalQuery = self.finalQuery.split(curQueryText).join('');
              self.finalQuery = self.finalQuery.concat(curQueryText);
            }
          } else {
            self.finalQuery = $($el).data(`rating${rating}`);
          }
          console.log(self.finalQuery);
        } else {
          document.location.search = $.query.set('q', $($el).data(`rating${rating}`));
        }

        const text = currentRating < 5 ? `${currentRating} AND UP` : currentRating;
        $($el).parents('.review').find('.review-text').text(text);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-facet-card/facet-card.js